export function extractSlateText(value: string | any[]): string {
  try {
    const nodes = Array.isArray(value) ? value : JSON.parse(value)

    const texts = nodes.map((node) => {
      if (node.text !== undefined) {
        return node.text
      }

      if (node.children) {
        return extractSlateText(node.children)
      }

      return ''
    })

    return texts.join(' ')
  } catch {
    return Array.isArray(value) ? '' : value
  }
}
